import * as React from "react";
import {observer} from "mobx-react";
import {Button} from "./Button";

@observer
export class AddButton extends Button {

  render() {
    return <Button {...this.props} >
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
          <polygon points="32 14.04 18 14.04 18 0 14.04 0 14.04 14.04 0 14.04 0 18 14.04 18 14.04 32 18 32 18 18 32 18 32 14.04"/>
        </svg>
      </i>
    </Button>;
  }
}
